<template>
  <div
    :class="['m-msg-outcome m-outcome', changeType, {
      'active': active && !isDisabled,
      'disabled': isDisabled,
      'm-msg-outcome--up': isUp,
      'm-msg-outcome--down': isDown,
      'multiple': showDesc
    }]"
    @click.stop="toogleSelected"
  >
    <i
      v-show="!isDisabled && (isUp || isDown)"
      :class="['m-icon-arrow', {
        'up': isUp,
        'down': isDown
      }]"
    />

    <div
      v-if="showDesc"
      class="desc"
    >
      {{ description || outcome.description }}
    </div>

    <img
      v-if="isDisabled"
      width="19px"
      src="~public/images/icon/locked.svg"
    >

    <div
      v-else
      class="odds"
    >
      {{ outcome.odds }}
    </div>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useWapBetslipStore } from 'wap/stores/betslip'
import useOutcome from '@ms/components/match/useOutcome.js'

export default {
  name: 'MarketOutcome',
  props: {
    outcome: {
      type: Object,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    market: {
      type: Object,
      default: () => null
    },
    event: {
      type: Object,
      default: () => null
    },
    // 显示类型，默认为空, multiple 支持 desc + odds
    changeType: {
      type: String,
      default: ''
    },
    showDesc: {
      type: Boolean,
      default: false
    },
    // 自定义 desc
    description: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { active, selectionId, isDisabled, isUp, isDown, updateStatus } = useOutcome(props)

    const { selectionList } = storeToRefs(useWapBetslipStore())

    return {
      active,
      selectionId,
      isDisabled,
      isUp,
      isDown,
      updateStatus,
      selectionList
    }
  },
  watch: {
    'market.specifiers': function () {
      this.$nextTick(() => {
        this.updateStatus(0)
      })
      // 切换 specifiers 要重新选择
      this.onSelectionsChange()
    }
  },
  created() {
    this.onSelectionsChange()
  },
  methods: {
    onSelectionsChange() {
      const { selectionId } = this
      if (this.selectionList.some((x) => x.id === selectionId)) {
        this.active = true
      }
    },
    toogleSelected(e) {
      e.preventDefault()
      if (this.isDisabled) return

      const active = useWapBetslipStore().toggleSelection({
        outcome: this.outcome,
        market: this.market,
        event: this.event
      })

      this.active = active
      this.$emit('click', active)
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");
@import url("~wap/common/style/mixin.less");

.m-msg-outcome {
  position: relative;
  display: flex;
  width: 64px;
  height: 44px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin-right: 2px;
  background: #333;
  color: @primary;
  cursor: pointer;
  line-height: 44px;
  text-align: center;

  &.active {
    background: @primary;
    color: #333;
  }

  &:last-child {
    margin-right: 0;
  }

  &&--up {
    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 2px;
      border-radius: 2px 2px 0 0;
      background: @green;
      content: "";
    }
  }

  &&--down {
    &::after {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      border-radius: 0 0 2px 2px;
      background: #e61818;
      content: "";
    }
  }

  &.disabled {
    color: #888;
    cursor: not-allowed;
  }

  .m-icon-arrow {
    .m-icon-trangle(4px;);

    position: absolute;
    right: 50%;
    margin-right: -4px;

    &.up {
      top: 2px;

      &::before {
        border-bottom-color: @green;
      }
    }

    &.down {
      bottom: 2px;

      &::before {
        border-top-color: #ff3826;
      }
    }
  }

  &.multiple {
    height: 36px;
    justify-content: space-between;
    padding: 0 10 / @rem;
    margin-right: 4px;
    line-height: 36px;

    &.active {
      .desc {
        color: #333;
      }

      .odds {
        color: #333;
      }
    }

    &:last-child {
      margin-right: 0;
    }

    .desc {
      flex: 1 1 auto;
      color: #b2b2b2;
      font-size: 12px;
      line-height: 14px;
      text-align: left;
    }

    .odds {
      flex: 1 1 auto;
      color: @primary;
      font-size: 12px;
      text-align: right;
    }

    &.disabled {
      justify-content: center;
    }
  }
}

</style>
